export const htmlToText = (html: string): string =>
    new DOMParser().parseFromString(html, 'text/html').body.textContent?.trim() || '';

export const htmlToTextPreserveBreaks = (html: string): string =>
    htmlToText(html.replaceAll(/<br\s*\/?>/gi, '\n'));
